// src/pages/Chat/PresenceDot.jsx
//
// Shows a small colored dot indicating a user's online/offline/away status.
// Reads from chatStore.presence map (populated by WS presence.update events
// and bulk-loaded on ChatPage mount via getPresence()).
//
// THIS WAS MISSING — referenced by ConversationItem and ConvHeader but never defined.

import React from "react";
import useChatStore from "../../store/chatStore";

/**
 * @param {string}  employeeId  — the user whose presence to show
 * @param {"sm"|"md"} size       — "sm" = 8px, "md" = 10px (default "sm")
 * @param {string}  className    — extra classes
 */
export default function PresenceDot({ employeeId, size = "sm", className = "" }) {
  const status = useChatStore((s) =>
    employeeId ? s.presence[employeeId] : undefined
  );

  if (!employeeId) return null;

  const dim = size === "md" ? "w-2.5 h-2.5" : "w-2 h-2";

  let colorClass = "bg-slate-600";           // unknown / no data
  let glowStyle  = {};

  if (status === "ONLINE") {
    colorClass = "bg-emerald-400";
    glowStyle  = { boxShadow: "0 0 5px rgba(52,211,153,0.8)" };
  } else if (status === "AWAY") {
    colorClass = "bg-amber-400";
    glowStyle  = { boxShadow: "0 0 5px rgba(251,191,36,0.7)" };
  } else if (status === "OFFLINE") {
    colorClass = "bg-slate-500";
  }

  return (
    <span
      className={`
        inline-block rounded-full border-2 border-slate-900
        ${dim} ${colorClass} ${className}
      `}
      style={glowStyle}
      title={status ? status.charAt(0) + status.slice(1).toLowerCase() : "Unknown"}
    />
  );
}

export function PresenceText({ employeeId, className = "" }) {
  const status = useChatStore((s) =>
    employeeId ? s.presence[employeeId] : undefined
  );

  if (!employeeId) return null;

  const isOnline = status === "ONLINE";
  const isAway = status === "AWAY";
  
  let colorClass = "text-slate-500";
  let text = "Offline";

  if (isOnline) {
    colorClass = "text-emerald-400";
    text = "Online";
  } else if (isAway) {
    colorClass = "text-amber-400";
    text = "Away";
  }

  return (
    <span className={`text-xs flex items-center gap-1.5 font-medium ${colorClass} ${className}`}>
      {isOnline && <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" style={{ boxShadow: "0 0 5px rgba(52,211,153,0.8)" }} />}
      {isAway && <span className="w-1.5 h-1.5 rounded-full bg-amber-400" style={{ boxShadow: "0 0 5px rgba(251,191,36,0.7)" }} />}
      {text}
    </span>
  );
}